/**
 * Returns the distinct elements in a given array.
 */
export const getDistinctElements = (array) => {
    return array.reduce((acc, item) => {
        const match = acc.findIndex(i => {
            if (typeof i === 'function') {
                return i === item;
            }
            return JSON.stringify(i) === JSON.stringify(item);
        }) !== -1;
        if (!match) {
            acc.push(item);
        }
        return acc;
    }, []);
};
//# sourceMappingURL=get-distinct-elements.js.map